import axios from "axios"
// import petPerMint from ""
export let sessionUserInfo = {}

export async function load() {
    const url = "/sessionRoute/getSessionUserInfo.do"
    let result = await axios.post(url)
    sessionUserInfo = result.data.sessionUserInfo
}
    
